import React, { useRef } from "react";
import { useClickOutside } from "./useClickOutside";
function ClickOutside(props) {
  const container = useRef(null);
  const { onClickOutside, triggerOn, ...restProps } = props;
  useClickOutside({ containerRef: container, onClickOutside, triggerOn });
  return /* @__PURE__ */ React.createElement("div", { ...restProps, ref: container }, props.children);
}
export {
  ClickOutside
};
//# sourceMappingURL=ClickOutside.js.map
